const actionTypes = {
  // Initialize Constants
  FETCH_INITIALIZE: "FETCH_INITIALIZE",
  FETCH_INITIALIZE_FAILED: "FETCH_INITIALIZE_FAILED",
  FETCH_INITIALIZE_SUCCESS: "FETCH_INITIALIZE_SUCCESS",

  // State Constants
  SELECT_DROPDOWN_STATE: "SELECT_DROPDOWN_STATE",
  SET_CURRENT_STATE: "SET_CURRENT_STATE",
  LOAD_STATE_FIELDS: "LOAD_STATE_FIELDS",
  RESET_CURRENT_STATE: "RESET_CURRENT_STATE",

  // WorkItem Form
  SET_FORM_FIELDS: "SET_FORM_FIELDS",

  // Request for Initialize Fields
  FETCH_FIELDS: "FETCH_FIELDS",
  SANITIZE_FIELDS: "SANITIZE_FIELDS",
  SANITIZE_FIELDS_SUCCESS: "SANITIZE_FIELDS_SUCCESS",
  SANITIZE_FIELDS_FAILURE: "SANITIZE_FIELDS_FAILURE",
  FETCH_FIELDS_SUCCESS: "FETCH_FIELDS_SUCCESS",
  FETCH_FIELDS_FAILED: "FETCH_FIELDS_FAILED",

  // Auth Constants
  REDIRECT_LOGIN: "REDIRECT_LOGIN",
  REDIRECT_LOGIN_FAILED: "REDIRECT_LOGIN_FAILED",
  REDIRECT_LOGOUT: "REDIRECT_LOGOUT",
  REDIRECT_LOGOUT_FAILED: "REDIRECT_LOGOUT_FAILED",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  REFERRER_REDIRECT_FAILED: "REFERRER_REDIRECT_FAILED",

  // Change Password
  CHANGE_PASSWORD: "CHANGE_PASSWORD",

  // Change Role
  CHANGE_ROLE: "CHANGE_ROLE",
  GHOSTING_COMPANIES: "GHOSTING_COMPANIES",
  SET_GHOSTING_COMPANIES: "SET_GHOSTING_COMPANIES",
  RESET_ROLE: "RESET_ROLE",
  IS_GHOSTING: "IS_GHOSTING",
  SET_GHOSTING_COMPANY: "SET_GHOSTING_COMPANY",

  // Workerlist Constants
  FETCH_WORK_ITEMS: "FETCH_WORK_ITEMS",
  FETCH_WORK_ITEMS_SUCCESS: "FETCH_WORK_ITEMS_SUCCESS",
  FETCH_WORK_ITEMS_FAILED: "FETCH_WORK_ITEMS_FAILED",
  RESET_WORK_ITEMS: "RESET_WORK_ITEMS",

  CHANGE_WORKLIST_FILTER: "CHANGE_WORKLIST_FILTER",
  RESET_WORKLIST_FILTER: "RESET_WORKLIST_FILTER",
  CHANGE_FILTER_INPUT: "CHANGE_FILTER_INPUT",
  RESET_FILTER_INPUT: "RESET_FILTER_INPUT",

  CREATE_WORK_ITEM: "CREATE_WORK_ITEM",
  CREATE_WORK_ITEM_SUCCESS: "CREATE_WORK_ITEM_SUCCESS",
  CREATE_WORK_ITEM_FAILED: "CREATE_WORK_ITEM_FAILED",
  CANCEL_WORKITEM: "CANCEL_WORKITEM",
  GENERATE_WORKITEM_REPORT: "GENERATE_WORKITEM_REPORT",
  GENERATE_WORKITEM_REPORT_SUCCESS: "GENERATE_WORKITEM_REPORT_SUCCESS",
  GENERATE_WORKITEM_REPORT_FAILED: "GENERATE_WORKITEM_REPORT_FAILED",
  WORKITEM_REPORT_IN_PROGRESS: "WORKITEM_REPORT_IN_PROGRESS",
  CHANGE_STATE_CLONE_WORKITEM: "CHANGE_STATE_CLONE_WORKITEM",

  UPDATE_WORKITEM: "UPDATE_WORKITEM",
  SELECT_WORKITEM: "SELECT_WORKITEM",
  SET_CURRENT_WORKITEM: "SET_CURRENT_WORKITEM",
  ON_FIELDS_NEXT: "ON_FIELDS_NEXT",

  REQUEST_CHANGE_INPUT_VALUE: "REQUEST_CHANGE_INPUT_VALUE",
  CHANGE_INPUT_VALUE: "CHANGE_INPUT_VALUE",

  // Summary Constants
  FETCH_SUMMARY: "FETCH_SUMMARY",
  FETCH_SUMMARY_SUCCESS: "FETCH_SUMMARY_SUCCESS",
  FETCH_SUMMARY_FAILED: "FETCH_SUMMARY_FAILED",
  WORK_ITEM_PDF_REPORT: "WORK_ITEM_PDF_REPORT",

  RESET_ERROR: "RESET_ERROR",
  
  DISPLAY_MESSAGE: "DISPLAY_MESSAGE",
  REQUEST_DISPLAY_MESSAGE: "REQUEST_DISPLAY_MESSAGE",
  RESET_MESSAGE: "RESET_MESSAGE",

  API_REQUEST_SUCCESS: "API_REQUEST_SUCCESS",
  API_REQUEST_FAILURE: "API_REQUEST_FAILURE",

  // Loader Constants
  SHOW_LOADER: "SHOW_LOADER",
  HIDE_LOADER: "HIDE_LOADER",
  SHOW_FIELDS_LOADER: "SHOW_FIELDS_LOADER",
  HIDE_FIELDS_LOADER: "HIDE_FIELDS_LOADER",

  SHOW_NEXT_SECTION: "SHOW_NEXT_SECTION",
  HIDE_NEXT_SECTION: "HIDE_NEXT_SECTION",

  SECTION_MESSAGE: "SECTION_MESSAGE",

  ADD_MISC_FEE: "ADD_MISC_FEE",
  SET_MISC_FEE_VALUE: "SET_MISC_FEE_VALUE",
  SET_PRE1981DATA_VALUE:"SET_PRE1981DATA_VALUE",
  ENEABLE_QUESTIONAIRE_BUTTONS: "ENEABLE_QUESTIONAIRE_BUTTONS",
  // IFrame Constant
  OPEN_URL: "OPEN_URL",
  CLOSE_URL: "CLOSE_URL",

  TOGGLE_COLUMN_PICKER: "TOGGLE_COLUMN_PICKER",
  SET_COLUMN_ACTIVE: "SET_COLUMN_ACTIVE",
  SET_COLUMN_ORDER: "SET_COLUMN_ORDER",
  SET_COLUMN_VISIBLE: "SET_COLUMN_VISIBLE",

  GET_USER_ATTRIBUTES: "GET_USER_ATTRIBUTES",
  GET_USER_ATTRIBUTES_ERROR: "GET_USER_ATTRIBUTES_ERROR",
  SET_USER_ATTRIBUTES: "SET_USER_ATTRIBUTES",

  FETCH_APP_DATA: "FETCH_APP_DATA",
  SET_PREFERENCES: "SET_PREFERENCES",
  SET_APP_FEATURES: "SET_APP_FEATURES",

  SET_USER_OFFICE: "SET_USER_OFFICE",
  SET_USER_OFFICE_OPTIONS: "SET_USER_OFFICE_OPTIONS",

  //Worklist Actions
  CLONE_WORKITEM: "CLONE_WORKITEM",

  // Reports
  BASIC_USAGE_REPORT: "BASIC_USAGE_REPORT",
  BASIC_USAGE_DATA: "BASIC_USAGE_DATA",
  RESET_BASIC_USAGE: "RESET_BASIC_USAGE",

  //Pre 1981 VINs
  ENTER_DATA_MANUALLY:"ENTER_DATA_MANUALLY"

};

export default actionTypes;
